import type { EControlSettingType } from '../../type';
import type { IControlSettingUI } from '../types';

import { ChildrenControl } from './ChildrenControl';
import { getComponent } from '../constants';
import { memo } from 'react';

export interface ControlComponentProps {
  data: IControlSettingUI;
  type: EControlSettingType;
}

export const Control: React.FC<ControlComponentProps> = memo(({ data, type }) => {
  const Component = getComponent(data);

  if (data.hide) return null;

  return (
    <>
      <Component {...data} />
      <ChildrenControl data={data} type={type} />
    </>
  );
});

Control.displayName = 'Control';
